import { createContext } from 'react';
import { CodeEntryStore } from '../../store';

export const CodeEntryContext = createContext<CodeEntryStore | null>(null);
